import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/gongzhonghao.jpg'


const _withScopeId = n => (_pushScopeId("data-v-79eb87b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-left" }
const _hoisted_2 = { class: "left-item left-service" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-kefu1" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "客服", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_6 = { class: "show-more" }
const _hoisted_7 = { class: "show-more-contents" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left-item left-phone" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-gongzhonghao2" }),
  /*#__PURE__*/_createElementVNode("span", null, "公众号"),
  /*#__PURE__*/_createElementVNode("p"),
  /*#__PURE__*/_createElementVNode("div", { class: "show-more" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
  ])
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-jianyifankui2" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "建议反馈", -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-fanhuidingbu2" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "返回顶部", -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              href: "javascript:;",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.fangankefu && _ctx.fangankefu(...args)))
            }, "咨询设计方案")
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              href: "javascript:;",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.shouqiankefu && _ctx.shouqiankefu(...args)))
            }, "咨询备件(售前)")
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              href: "javascript:;",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.shouhoukefu && _ctx.shouhoukefu(...args)))
            }, "咨询备件(售后)")
          ])
        ])
      ])
    ]),
    _hoisted_8,
    _createElementVNode("div", {
      class: "left-item left-login",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goToUserCenter()))
    }, _hoisted_11),
    _createElementVNode("div", {
      class: "left-item left-toTop",
      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goToTop()))
    }, _hoisted_14)
  ], 512)), [
    [_vShow, _ctx.showBackToTop]
  ])
}